/* eslint-disable no-debugger */
/* eslint-disable max-len */
/* eslint-disable no-undef */
import axios from 'axios';
import { baseURL } from '../constants';
import { authHeader } from '../redux/helper';

async function DAPList(page, searchValue, filterValue, sort) {
    let data;
    try {
        if (searchValue !== '') {
            data = await axios.get(`${baseURL}/dap-policy/list?search=${encodeURIComponent(searchValue)}&limit=8&page=${page}${sort !== '' ? `&sort=${sort}` : ''}${filterValue === 'all' ? '' : `${filterValue}`}`, { headers: authHeader() });
        } else {
            data = await axios.get(`${baseURL}/dap-policy/list?limit=8&page=${page}${sort !== '' ? `&sort=${sort}` : ''}${filterValue === 'all' ? '' : `${filterValue}`}`, { headers: authHeader() });
        }

        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}
async function createPolicy(body) {
    try {
        const data = await axios.post(`${baseURL}/dap-policy/create`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function GetDapDetails(id) {
    try {
        const data = await axios.get(`${baseURL}/dap-policy/get/${id}`, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.response.data.message };
    }
}
async function UpdatePolicy(body, id) {
    try {
        const data = await axios.patch(`${baseURL}/dap-policy/update/${id}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}
async function policyActiveOrDeactivateAccount(body, code) {
    try {
        const data = await axios.patch(`${baseURL}/dap-policy/${body}/${code}`, body, {
            headers: authHeader(),
        });
        return { error: false, data: data.data };
    } catch (error) {
        return { error: true, message: error.message };
    }
}
const handleUrl = (url) => {
    let key = `/dap-policy/${url}`;
    if (url === 'admin-user/html-to-pdf') {
        key = '/pdf-converter/dap-policy/html-to-pdf';
    }
    return key;
};
async function handlePolicyExport(page, searchValue, filterValue, sort, sortKey) {
    let data;
    try {
        if (filterValue === '' || filterValue === undefined) {
            data = await axios.get(`${baseURL}${handleUrl(sortKey)}?page=${page}&limit=10${searchValue !== '' ? `&search=${encodeURI(searchValue.toLowerCase())}` : ''}${sort === '' ? '' : `&sort=${sort}`}`, { headers: authHeader() });
        } else {
            data = await axios.get(`${baseURL}${handleUrl(sortKey)}?page=${page}&limit=10${sort === '' ? '' : `&sort=${sort}&`}${filterValue.substring(1)}`, { headers: authHeader() });
        }
        return { error: false, data: data.data };
    } catch (error) {
        if (error.response.status === 401) {
            // logout();
        }
        return { error: true, message: error.response.data.message };
    }
}
export const DapService = {
    DAPList,
    createPolicy,
    GetDapDetails,
    UpdatePolicy,
    policyActiveOrDeactivateAccount,
    handlePolicyExport,
};
